import { LoginForm, Slider } from "components";
import { AppleBtn, GoogleBtn, ModeSwitch, SVG } from "ui";
import { appleBtn, logo, playstoreBtn } from "utils/assets_exports/images";

const Login = () => {
    return (
        <div className="login-wrapper">
            {/* <!-- Main Wrapper --> */}
            <div className="login-wrapper columns is-gapless">
                {/* <!--Left Side (Desktop Only)--> */}
                <div className="column is-6 is-hidden-mobile hero-banner">
                    <div className="hero is-fullheight is-login">
                        <div className="hero-body">
                            <div className="container flex-container">
                                {/* <!-- IOS simulator Slider  --> */}
                                <Slider />
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--Right Side--> */}
                <div className="column is-6">
                    <div className="hero form-hero is-fullheight">
                        <div className="d-flex w-100 flex-j-end pt-20 pr-20">
                            <ModeSwitch />
                        </div>
                        {/* <!--Logo--> */}
                        <div className="logo-wrap">
                            <div className="wrap-inner">
                                <img src={logo} alt="" />
                            </div>
                        </div>
                        {/* <!--Login Form--> */}
                        <div className="hero-body">
                            <div className="form-wrapper">
                                {/* <!--Avatar--> */}
                                <div className="avatar is-hidden-tablet">
                                    <img src={logo} alt="momeento logo" />
                                </div>
                                <div className="my-login-container is-hidden-mobile">
                                    <h2 className="form-title">
                                        Welcome Back, Momeento
                                    </h2>
                                    <h3 className="form-subtitle">
                                        Enter your credentials to sign in.
                                    </h3>
                                </div>

                                <LoginForm />

                                {/* <!-- forget pswd --> */}
                                <div className="section forgot-password">
                                    <div className="has-text-centered">
                                        <a href="#">Forgot password?</a>
                                    </div>
                                </div>

                                {/* <!-- fast login btns --> */}
                                <div className="form-wrapper">
                                    <div className="login-form">
                                        <GoogleBtn />
                                        <AppleBtn />
                                        {/* <!-- create account btn --> */}
                                        <div className="field">
                                            <div className="control">
                                                <a
                                                    href="./signup"
                                                    className="button raised is-rounded is-fullwidth d-flex gap-5"
                                                >
                                                    <SVG svg="user" size={22} />
                                                    Create Account
                                                </a>
                                            </div>
                                        </div>

                                        <div className="field">
                                            <div className="control">
                                                <h4 className="text-center mb-20 mt-30">
                                                    Download App
                                                </h4>
                                                <div className="d-flex flex-j-center">
                                                    <a href="#">
                                                        <img
                                                            src={appleBtn}
                                                            alt=""
                                                            className="mx-2"
                                                            style={{
                                                                width: "134px",
                                                                height: "40px"
                                                            }}
                                                        />
                                                    </a>
                                                    <a href="#">
                                                        <img
                                                            src={playstoreBtn}
                                                            alt=""
                                                            className="mx-2"
                                                            style={{
                                                                width: "134px",
                                                                height: "40px"
                                                            }}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- links nav --> */}
                        <div className="login-bottom-links d-flex flex-j-center gap-10 flex-wrap pb-30 pr-15 pl-15">
                            <a
                                className="px-2"
                                href="https://momeento.com/privacypolicy"
                            >
                                Privacy Policy
                            </a>
                            <a
                                className="px-2"
                                href="https://momeento.com/teamconditions"
                            >
                                Terms &amp; Conditions
                            </a>
                            <a
                                className="px-2"
                                href="https://momeento.com/teamconditions"
                            >
                                Cookies Policy
                            </a>
                            <a
                                className="px-2"
                                href="https://momeento.com/help/community"
                            >
                                Community Guideline
                            </a>
                            <a
                                className="px-2"
                                href="https://momeento.com/help/community"
                            >
                                Help
                            </a>
                            <a
                                className="px-2"
                                href="https://momeento.com/help/community"
                            >
                                @ 2023 Momeento Inc.
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
